<div>
  <div class="hub-navbar" [ngClass]="{ shadow: showShadow }">
    <div class="nav-background">
      <div class="hub-navbutton">
        <i class="fa fa-reorder"
           (click)="menuOpen = !menuOpen"
           [ngClass]="{ rotate: !menuOpen }"></i>
      </div>
      <div class="hub-navlogo">
        <img src="../../../../assets/hubtiger_logo_pink.png"/>
      </div>
      <div class="partner-name">Insurance Portal</div>
      <div class="menu-right" *ngIf="profile.Name">
        <!--      todo(dcorbett)  no notificationOpen-->
        <div class="profile"
             (click)="dropMenuOpen = !dropMenuOpen;">
          <avatar style="margin: auto;margin-right: 8px;"
                  size="45"
                  name="{{ profile.Name + ' ' + profile.Surname }}"
                  profilePhoto="{{ profile.ImageURL }}"></avatar>
          <a href="javascript:void(0)">{{ profile.Name }} {{ profile.Surname }}</a>
        </div>
        <div class="menu-drop-down" [ngClass]="{ 'drop-menu-open': !dropMenuOpen }">
          <ul>
            <!--<li routerLink="/administration/stores"
                *ngIf="profile.IsSuperUser">
              <span class="fa fa-fw fa-building"></span>Super User Portal
            </li>-->
            <!--<li routerLink="/clubs"
                *ngIf="profile.isAdmin || profile.IsSuperUser">
              <span class="fa fa-fw fa-bicycle"></span>{{ "general.cycle_club" | translate }}
            </li>-->
            <!--<li routerLink="myprofile" (click)="dropMenuOpen = !dropMenuOpen">
              <span class="fa fa-fw fa-user-o"></span>{{ "general.my_profile" | translate }}
            </li>-->
            <!--<li (click)="setPrinter()">
              <span class="fa fa-fw fa-print"></span>{{ "general.printer_setup" | translate }}
            </li>-->
            <!--            todo (dcorbett) no method named logout()-->
            <!--            <li (click)="logout()">-->
            <!--              <span class="fa fa-fw fa-sign-out"></span>{{ "general.logout" | translate }}-->
            <!--            </li>-->
          </ul>
        </div>
      </div>
      <div class="header-icon"
           style="margin-right: 8px;"
           pTooltip="{{ 'general.bike_shop_help' | translate }}"
           tooltipPosition="bottom">
        <a href="https://help.hubtiger.com/" target="_blank">
          <span class="fa fa-question"></span>
        </a>
      </div>
    </div>
  </div>
  <div class="hub-sidebar active"
       [ngClass]="{ 'close-menu': !menuOpen, shadowDown: showShadow }">
    <div class="hub-navbutton">
      <i class="fa fa-reorder"
         (click)="menuOpen = !menuOpen"
         [ngClass]="{ rotate: !menuOpen }"></i>
    </div>
    <div class="hub-navlogo">
      <img src="../../../../assets/hubtiger_logo_pink.png"/>
    </div>
    <div class="menu-container">
      <p-menu [model]="menuItems"></p-menu>
      <p-panelMenu [transitionOptions]="'400ms'"
                   [model]="adminSetupItems"
                   [multiple]="false"
      >
      </p-panelMenu>
    </div>
  </div>
  <div class="hub-content" [ngClass]="{ 'close-menu-content': !menuOpen }">
    <div class="hub-content-background"></div>
    <div>
      <!--*ngIf="profileDataLoaded"-->
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
<p-confirmDialog rejectIcon="" acceptIcon=""></p-confirmDialog>
